import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAnglesLeft,
  faAnglesRight,
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import "../style/Pagination.css";

const Pagination = ({ currentPage, totalPageCount, handlePageChange }) => {
  if (!totalPageCount || totalPageCount <= 1) return null;

  const isFirstPage = currentPage === 1;
  const isLastPage  = currentPage === totalPageCount;

  return (
    <div className="pagination-container">
      <button
        onClick={() => handlePageChange(1)}
        disabled={isFirstPage}
        className="pagination-button pagination-button--edge"
        aria-label="First page"
      >
        <FontAwesomeIcon icon={faAnglesLeft} />
      </button>

      <button
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={isFirstPage}
        className="pagination-button pagination-button--nav"
        aria-label="Previous page"
      >
        <FontAwesomeIcon icon={faChevronLeft} />
      </button>

      <div className="page-info">
        <span className="page-current">{currentPage}</span>
        <span className="page-sep">/</span>
        <span className="page-total">{totalPageCount}</span>
      </div>

      <button
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={isLastPage}
        className="pagination-button pagination-button--nav"
        aria-label="Next page"
      >
        <FontAwesomeIcon icon={faChevronRight} />
      </button>

      <button
        onClick={() => handlePageChange(totalPageCount)}
        disabled={isLastPage}
        className="pagination-button pagination-button--edge"
        aria-label="Last page"
      >
        <FontAwesomeIcon icon={faAnglesRight} />
      </button>
    </div>
  );
};

export default Pagination;